'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// define the stripe variable for initialization
var cardNumberElement = null;
var cardExpiryElement = null;
var cardCvcElement = null;
var cardPostalElement = null;
var stripe = null;

var AddCardModal = function (_React$Component) {
    _inherits(AddCardModal, _React$Component);

    function AddCardModal(props, context) {
        _classCallCheck(this, AddCardModal);

        var _this = _possibleConstructorReturn(this, (AddCardModal.__proto__ || Object.getPrototypeOf(AddCardModal)).call(this, props, context));

        _this.addPaymentMethod = function () {

            var self = _this;
            var currentUser = _parse2.default.User.current();

            var userName = document.getElementById("user-name").value;
            var regex = /^[a-zA-Z0-9][a-zA-Z0-9 ]*$/;
            // let userZip = document.getElementById("user-zip").value;

            // check the userName and userZip code validation
            if (Utils.isEmpty(userName)) {
                _this.setState({ error: 'User name is empty.' });
                return;
            } else {
                if (!regex.test(userName)) {

                    _this.setState({
                        error: "Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)"
                    });

                    return;
                }
            }

            _this.setState({ error: '', isCardBeingAdd: true });
            Utils.showSpinner();

            // billing details
            var billingDetails = {
                name: userName,
                email: currentUser.get("email"),
                phone: currentUser.get("phoneNumber")
            };

            // call the stripe function to create the Payment Method
            stripe.createPaymentMethod({
                type: 'card',
                card: cardNumberElement,
                billing_details: billingDetails
            }).then(function (result) {
                if (result.error) {
                    self.setState({
                        error: result.error.message,
                        isCardAdded: false,
                        isCardBeingAdd: false
                    }, function () {
                        Utils.hideSpinner();
                    });
                } else {
                    var paymentMethodId = result.paymentMethod.id;
                    self.attachPaymentMethod(paymentMethodId, billingDetails);
                }
            });
        };

        _this.resetErrorWaring = function () {
            if (!Utils.isEmpty(_this.state.error)) {
                _this.setState({ error: '' });
            }
        };

        _this.state = {
            error: '',
            isCardAdded: false,
            isCardBeingAdd: false
        };
        return _this;
    }

    _createClass(AddCardModal, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {

            // refresh the current parse user data
            Utils.refreshCurrentParseUser();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var self = this;

            var stripePublishableKey = _MainStore2.default.getStripePublishableKey();
            // console.log("stripePublishableKey:"+stripePublishableKey);

            // Initialize stripe data
            self.initializeStripeData(stripePublishableKey);

            // Add stripe mount on the card form
            cardNumberElement.mount('#card-number-element');
            cardExpiryElement.mount('#card-expiry-element');
            cardCvcElement.mount('#card-cvc-element');
            cardPostalElement.mount('#card-postal-element');

            // added the change event and card-error message
            cardNumberElement.addEventListener('change', function (event) {

                var displayError = "";
                if (event.error) {
                    displayError = event.error.message;
                } else {
                    displayError = '';
                }
                self.setState({ error: displayError });
            });

            //bootstrap modal show on comp mount.
            $('#cardModal').modal('show');
            $("#cardModal").on('hidden.bs.modal', function () {
                _this2.props.onHide(false);
            });
        }
    }, {
        key: 'initializeStripeData',
        value: function initializeStripeData(publishableKey) {

            // Initialize the Stripe and added Publishable API Key
            // console.log("publishableKey: " + publishableKey);
            stripe = Stripe(publishableKey);
            var elements = stripe.elements();
            // configure the style of card form
            var style = {
                base: {
                    color: "#32325d",
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "13px",
                    "::placeholder": {
                        color: "#aab7c4"
                    }
                },
                invalid: {
                    color: "#fa755a",
                    iconColor: "#fa755a"
                }
            };

            // Initialize the card elements and updated the style
            cardNumberElement = elements.create('cardNumber', {
                style: style
            });
            cardExpiryElement = elements.create('cardExpiry', {
                style: style
            });
            cardCvcElement = elements.create('cardCvc', {
                style: style
            });
            cardPostalElement = elements.create('postalCode', {
                style: style
            });
        }
    }, {
        key: 'attachPaymentMethod',
        value: function attachPaymentMethod(paymentMethodId, billingDetails) {
            var _this3 = this;

            var self = this;
            var currentUser = _parse2.default.User.current();
            var userId = currentUser.id;
            var sessionToken = currentUser.getSessionToken();
            var cus_id = currentUser.get("cus_id") ? currentUser.get("cus_id") : "";

            var paymentObject = {
                "paymentMethodId": paymentMethodId,
                "customerId": cus_id,
                "customerDetails": billingDetails
            };

            _Api2.default.attachPaymentMethod(userId, sessionToken, paymentObject).then(function (response) {

                // refresh the current parse user data
                Utils.refreshCurrentParseUser();

                self.setState({
                    isCardAdded: true,
                    isCardBeingAdd: false
                }, function () {
                    //hide bootstrap modal
                    $('#cardModal').modal('hide');
                    _this3.props.onHide(true);
                });
            }, function (error) {

                Utils.checkErrorIsInvalidSessionToken(error, self.context.router, false);
                Utils.hideSpinner();
                // self.handleHideModal();
                var errorMsg = "";
                if (error && error.responseJSON.error.message) {
                    errorMsg = error.responseJSON.error.message;
                }
                self.setState({
                    error: errorMsg,
                    isCardAdded: false,
                    isCardBeingAdd: false
                });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var self = this;
            if (self.props.parentClass == 'account') {
                $(this.refs.collapseOne).off('shown.bs.collapse hidden.bs.collapse');
            }

            //hide modal if open while unmounting
            if ($('#cardModal').hasClass('show')) {
                // The modal is open, so you can hide it
                $('#cardModal').modal('hide');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'modal fade',
                    id: 'cardModal', tabIndex: '-1', role: 'dialog',
                    'aria-labelledby': 'modalLabel', 'aria-hidden': 'true',
                    'data-keyboard': 'false', 'data-backdrop': 'static'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-dialog modal-dialog-centered modal-md', role: 'document' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-header' },
                            _react2.default.createElement(
                                'h5',
                                { className: 'modal-title text-center', id: 'modalLabel' },
                                'ADD NEW CARD'
                            ),
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'close', 'data-dismiss': 'modal',
                                    'aria-label': 'Close' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '\xD7'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-body pt-1' },
                            !Utils.isEmpty(this.state.error) ? _react2.default.createElement(
                                'div',
                                { className: 'alert alert-danger mt-2', role: 'alert' },
                                _react2.default.createElement('i', { className: 'icofont-warning-alt ft-16 mr-1' }),
                                this.state.error
                            ) : null,
                            this.state.isCardAdded ? _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'alert alert-success', role: 'alert' },
                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' }),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'sr-only' },
                                        'Success:'
                                    ),
                                    'Card added successfully.'
                                )
                            ) : null,
                            !this.state.isCardAdded ? _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'cell example example3', id: 'example-3' },
                                    _react2.default.createElement(
                                        'form',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'fieldset' },
                                            _react2.default.createElement('input', { id: 'user-name',
                                                'data-tid': 'elements_examples.form.name_label',
                                                className: 'field', type: 'text',
                                                placeholder: 'Name', required: '',
                                                autoComplete: 'name', onKeyPress: this.resetErrorWaring })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'fieldset pt-3' },
                                            _react2.default.createElement('div', { id: 'card-number-element',
                                                className: 'field empty text-secondary-light' }),
                                            _react2.default.createElement('div', { id: 'card-expiry-element',
                                                className: 'field empty third-width text-secondary-light' }),
                                            _react2.default.createElement('div', { id: 'card-cvc-element',
                                                className: 'field empty third-width text-secondary-light' }),
                                            _react2.default.createElement('div', { id: 'card-postal-element',
                                                className: 'field empty third-width text-secondary-light' })
                                        )
                                    )
                                )
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-footer' },
                            _react2.default.createElement(_SpinButton2.default, {
                                classNames: 'd-flex swal2-confirm w-50 ft-14 font-weight-bold text-center justify-content-center btn custom-btn-outline-primary',
                                buttonText: 'CANCEL',
                                spinText: "",
                                showSpinner: false,
                                'data-dismiss': 'modal',
                                showIcon: false,
                                iconClass: ""
                            }),
                            _react2.default.createElement(_SpinButton2.default, {
                                classNames: 'btn btn-styl ft-14 font-weight-bold d-flex w-50 text-center justify-content-center ' + (this.state.isCardBeingAdd ? "disabled-btn" : ""),
                                buttonText: 'SUBMIT',
                                spinText: "",
                                showSpinner: false,
                                whenClicked: this.addPaymentMethod.bind(this),
                                showIcon: false,
                                iconClass: ""
                            })
                        )
                    )
                )
            );
        }
    }]);

    return AddCardModal;
}(_react2.default.Component);

exports.default = AddCardModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/AddCardModal.jsx
// module id = 555
// module chunks = 0